import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import ReportListView from '../components/reportView/ReportListView';
import ReportViewTop from '../components/reportView/ReportViewTop';
import ReportDetailView from '../components/reportView/ReportDetailView';

import { setMapControl, enableMapToolbar, disableMapToolbar, toggleVehicleIcons } from '../features/map/mapSlice';
import { clearVisibleAssetsMarkers, restoreVisibleAssetsMarkers } from '../features/assets/assetsSlice';
import { liveTrackinglayoutSelector } from '../features/layout/layoutSlice';


const ReportView = () => {

    const dispatch = useDispatch();
    const dimentions = useSelector(liveTrackinglayoutSelector);

    useEffect(() => {
        dispatch(clearVisibleAssetsMarkers());
        dispatch(toggleVehicleIcons(false));
        dispatch(disableMapToolbar());
        return () => {
            dispatch(setMapControl('asset'));
            dispatch(restoreVisibleAssetsMarkers());
            dispatch(toggleVehicleIcons(true));
            dispatch(enableMapToolbar());
        }
    }, [dispatch]);


    return (
        <div style={dimentions.sidebar}>
            <div style={dimentions.trackViewTop}>
                <ReportViewTop />
            </div>
            <div style={{ ...dimentions.trackViewBottom, overflow: 'auto' }}>
                <ReportListView />
            </div>
            <div>
                <ReportDetailView />
            </div>
        </div>
    );
}

export default ReportView;